module.exports = __webpack_public_path__ + "img/logo.f2d4ea1b.png";